import { render, staticRenderFns } from "./fbpComponentGrouping.vue?vue&type=template&id=f92d235a&scoped=true"
import script from "./fbpComponentGrouping.vue?vue&type=script&lang=js"
export * from "./fbpComponentGrouping.vue?vue&type=script&lang=js"
import style0 from "./fbpComponentGrouping.vue?vue&type=style&index=0&id=f92d235a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92d235a",
  null
  
)

export default component.exports